import withDelayedHoverEvent from "app/pages/sales-intelligence/hoc/withDelayedHoverEvent";
import type { ComponentType, MouseEvent, MouseEventHandler } from "react";

type TrackingService = {
    trackClicked?(metadata: Record<string, unknown>): void;
    trackHovered?(metadata: Record<string, unknown>): void;
};

type ExpectedProps<M = Record<string, unknown>> = {
    metadata: M;
};

type HocProps = {
    onMouseEnter?: MouseEventHandler;
    onMouseLeave?: MouseEventHandler;
    onClick?: MouseEventHandler;
};

const withTrackedMouseEvents = <P extends HocProps, T extends TrackingService>(
    Component: ComponentType<P>,
    trackingService: T,
) => {
    const ComponentWithDelayedHoverEvent = withDelayedHoverEvent(Component);

    return function WrappedWithTrackedMouseEvents<M extends Record<string, unknown>>({
        metadata,
        onClick,
        onMouseEnter,
        ...buttonProps
    }: P & ExpectedProps<M>) {
        function handleTrackedClick(event: MouseEvent): void {
            trackingService.trackClicked?.(metadata);
            onClick?.(event);
        }

        function handleTrackedMouseEnter(event: MouseEvent): void {
            trackingService.trackHovered?.(metadata);
            onMouseEnter?.(event);
        }

        return (
            <ComponentWithDelayedHoverEvent
                {...(buttonProps as unknown as P)}
                onClick={handleTrackedClick}
                onMouseEnter={handleTrackedMouseEnter}
            />
        );
    };
};

export default withTrackedMouseEvents;
